import {Model, View} from "@lernetz/ts-lib";
import {gateway} from "../services/gateway";
import {languageService} from "../services/lang";
import {router} from "../services/router";
import template from "./Home.html";

export class HomeView extends View {
    constructor() {
        super({ template, data: new HomeController() });
    }

}

export class HomeController extends Model {
    topics: any;
    feeds: any;
    activeTopic: any;
    items: [];
    currentLang: any;

    applyFilter(tag) {
        this.activeTopic !== tag ? this.activeTopic = tag : this.activeTopic = false;
        this.updateUrl();
        if (this.activeTopic) {
            this.loadItems();
        } else {
            this.items = null;
        }
    }

    init() {
        this.currentLang = languageService.currentLang;
        gateway.loadTopics().then(topics => {
            this.topics = topics
            this.activeTopic = this.parseParams();
            if (this.activeTopic) {
                this.loadItems();
            }
        });
        gateway.toolGateway.feed().then( tools => {
            this.feeds = tools
        });
    }

    loadItems() {
        gateway.toolGateway
            .loadFilteredTools(this.createParams(this.activeTopic))
            .then((tools) => (this.items = tools));
    }

    private updateUrl() {
        const params = this.createParams(this.activeTopic);
        const newUrl = params ? `/${this.currentLang}/home/${params}` : '/';
        router.writeURL(newUrl);
    }

    private createParams(filters) {
        const paramParts = [];
        if (filters) {
            paramParts.push(`tags=${filters.slug}`);
        }
        const paramsUrl = paramParts.length ? `?${paramParts.join("&")}` : "";
        return paramsUrl;
    }

    private parseParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const tag = searchParams.has("tags") ? searchParams.get("tags") : null
        return this.activeTopic = this.topics.tags.find( t => t.slug === tag)
    }
}
